<app-small-header textColor="#fff" [homePage]="true" [class.blog-header]="isBlogRoute"></app-small-header>
<router-outlet></router-outlet>
<!-- <app-bottom-popup-banner></app-bottom-popup-banner> -->
@if (!isBlogRoute) {
<app-footer></app-footer>
<div class="callus-btn">
  <a href="tel:919555033033" target="_blank" class="callus-img">
    <img src="/assets/images/social-media/phone-call.png" alt="Chat on WhatsApp" style="width: 45px; height: 45px" />
    <span class="callus-tooltip-text">Call us</span>
  </a>
</div>
<div class="whatsapp-btn">
  <a href="https://wa.me/919555033033?text=Hello%20Team%20Udaan%20!%20I%20was%20browsing%20your%20website%20%26%20would%20like%20to%20know%20more%20on%20Locations%20%2F%20Rooms%20%26%20tariff"
    target="_blank" class="whatsapp-img">
    <img src="/assets/images/social-media/whatsapp-img.png" alt="Chat on WhatsApp" style="width: 45px; height: 45px" />
    <span class="tooltip-text">WhatsApp us</span>
  </a>
</div>
}
